import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Silence benign ResizeObserver loop warnings (Radix + framer-motion) that
// otherwise get promoted to the CRA dev error overlay.
window.addEventListener(
  "error",
  (e) => {
    if (e.message && /ResizeObserver loop/.test(e.message)) {
      e.stopImmediatePropagation();
    }
  },
  true
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
